import script from "./Conversion_activationcode.vue?vue&type=script&setup=true&lang=js"
export * from "./Conversion_activationcode.vue?vue&type=script&setup=true&lang=js"

import "./Conversion_activationcode.vue?vue&type=style&index=0&id=263de40a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263de40a"]])

export default __exports__